export default __webpack_public_path__ + "static/media/product-page2.fafec2dd.png";